export function uuid(): string {
  let uuid = ''
  const chars = '0123456789abcdef'

  for (let i = 0; i < 32; i++) {
    const randomIndex = Math.floor(Math.random() * 16)
    uuid += chars[randomIndex]
  }

  // Insert dashes to match the UUID format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
  uuid = `${uuid.slice(0, 8)}-${uuid.slice(8, 12)}-${uuid.slice(12, 16)}-${uuid.slice(
    16,
    20
  )}-${uuid.slice(20)}`

  return uuid
}
